import { UNMAPPED_COLORS } from '@src/helpers/constants/colors'
import { createGlobalStyle } from 'styled-components'

// Global styles
const GlobalStyles = createGlobalStyle`
    *{
      box-sizing:border-box;
      -webkit-tap-highlight-color: transparent;
    }
  
    input[type=text],
    input[type=email],
    input[type=password],
    textarea {
      appearance: none;
    }
    
    input, input:before, input:after, textarea {
      user-select: initial;
    } 
  
    input[type="search"]::-webkit-search-decoration,
    input[type="search"]::-webkit-search-cancel-button,
    input[type="search"]::-webkit-search-results-button,
    input[type="search"]::-webkit-search-results-decoration {
      appearance:none;
    }
  
    html {
      height: 100%;
      box-sizing: border-box;
      -ms-overflow-style: scrollbar;
      overflow:auto;
    }
    body {
      background-color: ${(props) => props.theme.palette.white};
      color: ${(props) => props.theme.palette.dark};
      font-family: ${(props) => props.theme.font.primary};
      font-size: ${(props) => props.theme.font.sizes.default};
      margin: 0;
      button,
      input,
      select,
      textarea {
        font-family: ${(props) => props.theme.font.primary};
      }
      h1,h2,h3,h4,h5,h6{
        margin:0 0 .5rem 0;
        font-family: inherit;
        font-weight: ${(props) => props.theme.font.weights.normal};
        color: inherit;
      }
      p{
        line-height: 1.45rem;
      }
    }
  
    ::-webkit-scrollbar {
      width: 5px;
      height: 3px;
    }

    @media only screen and (min-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
      ::-webkit-scrollbar {
        width: 10px;
        height: 5px;
      }
    }
  
    ::-webkit-scrollbar-track {
      border-radius: 0px;  
    }
    
    ::-webkit-scrollbar-thumb {
      background: #aaa; 
      border-radius: 10px;
      transition-duration:.2s;
    }
  
    ::-webkit-scrollbar-thumb:hover {
      background: #ddd; 
    }
  
    .is-active{
      color: ${(props) => props.theme.palette.primary} !important;
    }


    body {
      margin: 0;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
        "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
        sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
    
    code {
      font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
        monospace;
    }
    
    #root {
      background-color: white;
      font-family: Roboto, sans-serif;
      min-height: calc(100vh - 40px);
    }

    .assign-strikes-table {
      height: calc(100% - 40px);
    }

    .assign-strikes-table .pagination-bottom {
      display: none;
    }    

  /* DayPicker styles */

  .DayPicker {
    display: inline-block;
    font-size: 1rem;
    outline: 0;
  }

  .DayPicker-wrapper {
    position: relative;
    outline: 0;
    flex-direction: row;
    padding-bottom: 1em;

    -webkit-user-select: none;

    -moz-user-select: none;

    -ms-user-select: none;

    user-select: none;
  }

  .DayPicker-Months {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .DayPicker-Month {
    display: table;
    outline: 0;
    margin: 0 1em;
    margin-top: 1em;
    border-spacing: 0;
    border-collapse: collapse;

    -webkit-user-select: none;

    -moz-user-select: none;

    -ms-user-select: none;

    user-select: none;
  }

  .DayPicker-NavBar {
  }

  .DayPicker-NavButton {
    position: absolute;
    right: 1.9em;
    left: auto;
    display: inline-block;
    margin-top: 2px;
    width: 2.2em;
    height: 2.2em;
    background-position: center;
    background-size: 50%;
    background-repeat: no-repeat;
    color: #8b9898;
    cursor: pointer;
  }

  .DayPicker-NavButton:hover {
    opacity: 0.8;
  }

  .DayPicker-NavButton--prev {
    margin-right: 1.9em;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAVVJREFUWAnN2G0KgjAYwPHpGfRkaZeqvgQaK+hY3SUHrk1YzNLay/OiEFp92I+/Mp2F2Mh2lLISWnflFjzH263RQjzMZ19wgs73ez0o1WmtW+dgA01VxrE3p6l2GLsnBy1VYQOtVSEH/atCCgqpQgKKqYIOiq2CBkqtggLKqQIKgqgCBjpJ2Y5CdJ+zrT9A7HHSTA1dxUdHgzCqJIEwq0SDsKsEg6iqBIEoq/wEcVRZBXFV+QJxV5mBtlDFB5VjYTaGZ2sf4R9PM7U9ZU+lLuaetPP/5Die3ToO1+u+MKtHs06qODB2zBnI/jBd4MPQm1VkY79Tb18gB+C62FdBFsZR6yeIo1YQiLJWMIiqVjQIu1YSCLNWFgijVjYIuhYYCKoWKAiiFgoopxYaKLUWOii2FgkophYp6F3r42W5A9s9OcgNvva8xQaysKXlFytoqdYmQH6tF3toSUo0INq9AAAAAElFTkSuQmCC");
  }

  .DayPicker-NavButton--next {
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAXRJREFUWAnN119ugjAcwPHWzJ1gnmxzB/BBE0n24m4xfNkTaOL7wOtsl3AXMMb+Vjaa1BG00N8fSEibPpAP3xAKKs2yjzTPH9RAjhEo9WzPr/Vm8zgE0+gXATAxxuxtqeJ9t5tIwv5AtQAApsfT6TPdbp+kUBcgVwvO51KqVhMkXKsVJFXrOkigVhCIs1Y4iKlWZxB1rX4gwlpRIIpa8SDkWmggrFq4IIRaJKCYWnSgnrXIQV1r8YD+1Vrn+bReagysIFfLABRt31v8oBu1xEBttfRbltmfjgEcWh9snUS2kNdBK6WN1vrOWxObWsz+fjxevsxmB1GQDfINWiev83nhaoiB/CoOU438oPrhXS0WpQ9xc1ZQWxWHqUYe0I0qrKCQKjygDlXIQV2r0IF6ViEBxVTBBSFUQQNhVYkHIVeJAtkNsbQ7c1LtzP6FsObhb2rCKv7NBIGoq4SDmKoEgTirXAcJVGkFSVVpgoSrXICGUMUH/QBZNSUy5XWUhwAAAABJRU5ErkJggg==");
  }

  .DayPicker-NavButton--interactionDisabled {
    display: none;
  }

  .DayPicker-Caption {
    display: table-caption;
    margin-bottom: 0.5em;
    padding: 0 0.5em;
    text-align: left;
  }

  .DayPicker-Caption > div {
    font-weight: 500;
    font-size: 1.15em;
  }

  .DayPicker-Weekdays {
    display: table-header-group;
    margin-top: 1em;
  }

  .DayPicker-WeekdaysRow {
    display: table-row;
  }

  .DayPicker-Weekday {
    display: table-cell;
    padding: 0.5em;
    color: #8b9898;
    text-align: center;
    font-size: 0.875em;
  }

  .DayPicker-Weekday abbr[title] {
    border-bottom: none;
    text-decoration: none;
  }

  .DayPicker-Body {
    display: table-row-group;
  }

  .DayPicker-Week {
    display: table-row;
  }

  .DayPicker-Day {
    display: table-cell;
    height: 40px;
    width: 40px;
    padding: 0.5em;
    border-radius: 50%;
    vertical-align: middle;
    text-align: center;
    cursor: pointer;
    outline: 0;
  }

  .DayPicker-WeekNumber {
    display: table-cell;
    padding: 0.5em;
    min-width: 1em;
    border-right: 1px solid #eaecec;
    color: #8b9898;
    vertical-align: middle;
    text-align: right;
    font-size: 0.75em;
    cursor: pointer;
  }

  .DayPicker--interactionDisabled .DayPicker-Day {
    cursor: default;
  }

  .DayPicker-Footer {
    padding-top: 0.5em;
  }

  .DayPicker-TodayButton {
    border: none;
    background-color: transparent;
    background-image: none;
    box-shadow: none;
    color: #03a9f4;
    font-size: 0.875em;
    cursor: pointer;
  }

  /* Default modifiers */

  .DayPicker-Day--today {
    color: #eb4d4b;
    font-weight: 700;
  }

  .DayPicker-Day--outside {
    color: #8b9898;
    cursor: default;
  }

  .DayPicker-Day--disabled {
    color: #dce0e0;
    cursor: default;
    /* background-color: #eff1f1; */
  }

  /* Example modifiers */

  .DayPicker-Day--sunday {
    background-color: #f7f8f8;
  }

  .DayPicker-Day--sunday:not(.DayPicker-Day--today) {
    color: #dce0e0;
  }

  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
    position: relative;
    background-color: #03a9f4;
    color: #f0f8ff;
  }

  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {
    background-color: #03a9f4;
  }

  .DayPicker:not(.DayPicker--interactionDisabled)
    .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {
    background-color: #f0f8ff;
  }

  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
    width: 20px;
    height: 20px;
    border-radius: 4px;
  }

  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {
    width: 20px;
    height: 20px;
    border-radius: 4px;
  }

  .DayPicker-Day {
    width: 30px;
    height: 30px;
    border-radius: 4px;
  }

  /* 
  React quill
  */

 #EMAIL_editor {
  height: 450px;
}

.rich_text_editor__hasError .ql-toolbar.ql-snow {
  border: 1px solid #e86767;
}

.rich_text_editor__hasError .ql-toolbar.ql-snow {
  border: 1px solid #e86767;
}

.rich_text_editor__hasError .ql-container.ql-snow {
  border: 1px solid #e86767;
}

.rich_text_editor__isDisabled {
  opacity: 0.4;
}

.rich_text_editor__isDisabled .ql-toolbar .ql-formats{
  cursor: not-allowed;
}

.rich_text_editor__isDisabled .ql-toolbar .ql-formats button {
  pointer-events: none;
}

.rich_text_editor__isDisabled .ql-container {
  cursor: not-allowed;
}

.rich_text_editor__isDisabled .ql-container .ql-editor {
  pointer-events: none;
}

.rich_text_display {
  // We use this class when displaying HTML generated from the rich text editor.
  // There we pass the class .ql-editor, so we benefit from some styles for nested lists etc.
  // But in .ql-editor class (whose styles are also applied on the rich editor itself), the white-space: pre-wrap property adds a lot of white space between lines.
  // This way we overwrite it, but will need to revisit and handle this in a more elegant way (make sure to check older quill implementations and clean up this file).
  white-space: normal !important;
}

#EMAIL_editor .ql-container {
  height: 410px;
}

.EMAIL_editor-errorText {
  color: #e86767;
  font-size: 12px;
  margin: 5px 0;
}

  /* DayPickerInput */

  .DayPickerInput {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  }

  .DayPickerInput input {
    outline: none;
    cursor: pointer;
    color: #666;
    border: 0.5px solid #d9d9d9;
    border-radius: 4px;
    width: 100%;
    transition: all ease-in-out 0.2s;
    font-size: 11px;
    text-align: center;
    height: 25px;
  }

  .DayPickerInput input:hover {
    border-color: #03a9f4;
  }

  .DayPickerInput-OverlayWrapper {
    position: absolute;
    overflow: visible;
    width: 180px;
    color: #242728;
    z-index: 3;
  }

  .DayPickerInput-Overlay {
    position: absolute;
    top: auto;

    background: #fff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  }

  .DayPickerInput-Overlay {
    top: 15px;
    left: 0px;
  }


  .ReactTable .rt-tr {
    height: 45px;
  }
  

  .ShiftDocumentationTable {
    margin-bottom: ${({ theme }) => `${theme.mp.md}`};
    margin-right: 0;
    margin-top: ${({ theme }) => `${theme.mp.md}`};
  }
  
  .PunchCardsTable .rt-tr {
    height: 40px;
  }
  
  .PunchCardsTable .rt-th,
  .PunchCardsTable .rt-td {
    overflow: visible;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .PunchCardsTable {
    border: 1px solid rgba(0, 0, 0, 0.1) !important;
  }

  .PunchCardsTable .halfPunch {
    background-color: #23CBA71A;
  }
  
  .PunchCardsTable .rt-td:last-child {
    overflow: visible;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  
  .PunchCardsTable .rt-td input {
    padding: 7px 10px;
    height: 26px;
    font-size: 11px;
    line-height: 11px;
    border-radius: 4px;
    text-align: center;
    width: 80%;
  }
  
  .PunchCardsTable .rt-td:nth-child(4) > div > div,
  .PunchCardsTable .rt-td:nth-child(5) > div > div {
    width: 46%;
  }
  
  .PunchCardsTable .rt-td:nth-child(4) > div > span,
  .PunchCardsTable .rt-td:nth-child(5) > div > span {
    width: 45%;
  }
  
  .PunchCardsTable .rt-td:nth-child(4) > div > button,
  .PunchCardsTable .rt-td:nth-child(5) > div > button {
    margin: 0 5px;
    padding: 0 2px;
  }
  
  .PunchCardsTable .rt-td:nth-child(4) input,
  .PunchCardsTable .rt-td:nth-child(5) input {
    width: 100%;
  }
  
  .PunchCardsTable .rt-td:nth-child(6) > div {
    width: 100%;
    flex: 0 1 auto !important;
    height: 26px;
    font-size: 11px;
  }
  
  .PunchCardsTable .rt-td:nth-child(6) > div > div {
    height: 24px;
  }
  
  .PunchCardsTable .rt-td:nth-child(6) > div > div > div {
    height: 24px;
  }
  
  .PunchCardsTable .rt-td:nth-child(6) > div > div > div > div {
    padding: 3px;
  }
  
  .PunchCardsTable.-highlight .rt-tbody .rt-tr:not(.-padRow) {
    transition: background 0.3s;
  }


  #InviteApplicantsTable tr th:first-child,
  #InviteApplicantsTable tr td:first-child{
    padding-right: 0 !important;
  }

#TimesheetsTable td, #InvoicesTable td {
  font-size: 12px;
}

#LocationTable thead th {
  padding: 15px 5px !important;
  background-color: ${UNMAPPED_COLORS.tableHeaderCellBg};
}

#LocationTable tbody tr {
background-color: #fff;

 &:hover {
  background-color: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05)
  }

  &:last-child {
    border-bottom: none;
  }
}




#LocationTable tbody td {
  padding: 15px 5px !important;
  font-size: 11px;
}

.notifications-component {
   &.notifications-upshift {
       .notification__item--success {
           background-color: ${({ theme: { palette } }) => palette.success_500};
           border-left: 8px solid ${({ theme: { palette } }) => palette.success_600};
      }
        .notification__item--danger {
           background-color: ${({ theme: { palette } }) => palette.danger};
           border-left: 8px solid ${({ theme: { palette } }) => palette.danger_500};
      }
        .notification__item--warning {
           background-color: ${({ theme: { palette } }) => palette.warning};
           border-left: 8px solid ${({ theme: { palette } }) => palette.warning_500};
      }
         .notification__item--info {
           background-color: ${({ theme: { palette } }) => palette.primary};
           border-left: 8px solid ${({ theme: { palette } }) => palette.primary_500};
      }
         .notification__item--default {
           background-color: ${({ theme: { palette } }) => palette.muted};
           border-left: 8px solid ${({ theme: { palette } }) => palette.dark};
      }
           
         .notification__item--default .notification__timer {
           background-color: ${({ theme: { palette } }) => palette.dark};
      }
         .notification__item--info .notification__timer {
           background-color: ${({ theme: { palette } }) => palette.primary_500};
      }
        .notification__item--warning .notification__timer {
           background-color: ${({ theme: { palette } }) => palette.warning_500};
      }
        .notification__item--danger .notification__timer {
           background-color: ${({ theme: { palette } }) => palette.danger_500};
      }
        .notification__item--success .notification__timer {
           background-color: ${({ theme: { palette } }) => palette.success_600};
      }
   }
}

.popper[data-popper-reference-hidden] {
  visibility: hidden;
  pointer-events: none;
}

#MultidayTable {
  thead, th {
    background: #ebeef7;
    font-size: 14px !important;  
  }
}

#IndividualDaysTable {
  thead, th {
    background: #ebeef7;
    font-size: 14px !important;
  }
}

.SettingsTable .rt-thead {
  padding: 6px 0;
  height: auto;
  background: #eceef8;
}

.ShiftActivityTable .rt-tbody .rt-tr-group {
  border: none;
} 
`

export { GlobalStyles }
